export default __webpack_public_path__ + "static/media/logoCores.4ada1c5f.svg";